export const footerText = '© Powered by F-Link';
